import Routes from './Components/Routes';
import {UserProvider} from './Components/UserContext'
import 'antd/dist/antd.css';
import './App.css';

function App() {
  return (
    <UserProvider>
      <Routes />
    </UserProvider>
  );
}

export default App;
